module.exports = __webpack_public_path__ + "static/itsm_capabilities_1-3f991fcfc811db2f5010b69884b227ef.png";